import React from 'react';
import './Legend.css'; // Make sure this import exists

const Legend = ({ pieceMap, highlightedPiece, setHighlightedPiece }) => {
  if (!pieceMap || pieceMap.size === 0) {
    return null;
  }

  const handleLegendItemClick = (piece) => {
    setHighlightedPiece(prev => prev === piece ? null : piece);
  };

  return (
    <div className="legend">
      <h4>Piece Legend</h4>
      <div className="legend-grid">
        {Array.from(pieceMap).map(([piece, id]) => (
          <div
            key={id}
            className={`legend-item ${highlightedPiece === piece ? 'highlighted-legend-item' : ''}`}
            onClick={() => handleLegendItemClick(piece)}
          >
            <span className="legend-number">{id}</span>
            <div
              className="legend-piece"
              style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/piece-images/${piece}.png)` }}
            ></div>
            <span className="legend-name">{piece}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Legend;